export enum MfaType {
    TOTP = 'TOTP',
    SMS = 'SMS',
}
